import type { SingleTeamInfo, SingleTeamInfoApi, TeamInfoApiData, TeamInfoData } from '../types';

function mapSingleTeamInfoApiToSingleTeamInfo(team: SingleTeamInfoApi): SingleTeamInfo {
  return {
    name: team.name,
    jersey: team.jersey,
    isNationalTeam: team.is_national_team ?? false,
  };
}

export default function mapTeamInfoApiDataToTeamInfoData(api: TeamInfoApiData): TeamInfoData {
  return {
    home: mapSingleTeamInfoApiToSingleTeamInfo(api.home),
    away: mapSingleTeamInfoApiToSingleTeamInfo(api.away),
    lineupAvailable: api.lineup_available,
  };
}
